import type { TypePolicies } from '../../../utils';
import { cursorPaginationFieldPolicy } from '../../../utils/policies/cursorPaginationFieldPolicy';

export const typePolicies: TypePolicies = {
  UnifiedApprovalsStatus: {
    fields: {
      stages: cursorPaginationFieldPolicy(['page', ['first']]),
    },
  },
};
